import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHZonaIns = async (credentials, data) => {
    const body = {
        service: "RNHZonaIns",
        params: {
            rnhZonaCod: data?.cod || null,
            rnhZonaNombre: data?.name || null,
            rnhZonaWKT: data?.wkt || null
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
